import React from 'react'

const Avatar = ({ className, src }) => {
  return <img className={className} src={src}></img>
}

export default Avatar
